const RELOADED_AT = 'live-survey:stale-asset-reload'
const GUARD_MS = 60_000

/**
 * Releases keep earlier hashed assets, so a tab opened before a release normally keeps loading
 * its pages. If a lazily loaded chunk still fails (removed, or a network error), reload once
 * to pick up the active release. A second failure within a minute is left to the router's
 * error handling instead of reloading in a loop; without session storage there is no guard,
 * so no reload either.
 */
export function installStaleAssetRecovery(
  target: Pick<Window, 'addEventListener' | 'sessionStorage' | 'location'> = window,
  now: () => number = Date.now,
): void {
  target.addEventListener('vite:preloadError', (event) => {
    try {
      const last = Number(target.sessionStorage.getItem(RELOADED_AT)) || 0
      if (now() - last < GUARD_MS) return
      target.sessionStorage.setItem(RELOADED_AT, String(now()))
    } catch {
      return
    }
    event.preventDefault()
    target.location.reload()
  })
}
